<div class="row">
    <div class="col-md-6 p-0">
        <app-grid [columns]="columns" [rows]="data.tableRows" [tableParams]="data.tableParams" [multiSelect]="false"
            [gridName]="gridName" (refreshDataFromServer)="refreshData($event)" [allowDelete]="true"
            (rowSelected)="rowSelectedEvent($event)" (addClicked)="addQuestionGroup()"
            (deleteClicked)="deleteQuestionGroup()" #gridComponent>
        </app-grid>
    </div>
    <div class="col-md-6 p-0 card">
        <div class="p-4 mr-0">
            <h5>{{mode}} Question Bank Group</h5>
            <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="submitQuestionGroup()">
                <div class="mb-3 mr-0 col-md-10">
                    <label class="form-label">Group Id</label>
                    <input [disabled]="mode != 'Add' && (selectedQuestionGroup?.noOfQuestions ?? 0) > 0" type="text"
                        class="form-control" [(ngModel)]="selectedQuestionGroup.questionGroupID"
                        [ngModelOptions]="{ standalone: true }">
                </div>
                <div class="mb-3 mr-0 col-md-10">
                    <label class="form-label">Name</label>
                    <input type="text" class="form-control" [(ngModel)]="selectedQuestionGroup.name"
                        [ngModelOptions]="{ standalone: true }">
                </div>
                <button class="btn btn-primary btn-lg col-md-10" type="submit">Save</button>
            </form>
        </div>
    </div>
</div>